import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import LoginStreak from './loginStreak';
import WeekPoints from './weekPoints';

class MyState extends React.Component {
  componentDidMount() {
    this.props.loadPointsThisWeek();
  }

  render() {
    return (
      <Row className="my-stats-container p-0 m-0 w-100">
        <Col xs={6} className="pl-0 left-col">
          <WeekPoints
            ptsWeek={this.props.pointsThisWeek}
            rank={this.props.rank}
            pointsThisWeekWaiting={this.props.pointsThisWeekWaiting}
          />
        </Col>
        <Col xs={6} className="pr-0 right-col">
          <LoginStreak
            day={this.props.loginStreak}
            longest={this.props.longestLoginStreak}
            loginStreakWaiting={this.props.loginStreakWaiting}
          />
        </Col>
      </Row>
    );
  }
}
MyState.propTypes = {
  statsData: PropTypes.object.isRequired,
};
export default MyState;
